import { combineReducers } from "redux";
import QuoteOverviewReducer from "./reducer/QuoteOverview";
import KeyMetricsReducer from "./reducer/KeyMetrics";
import GrowthMetricsReducer from "./reducer/GrowthMetrics";
import ValuationReducer from "./reducer/Valuation";
import MarketInfoReducer from "./reducer/MarketInfo";
export default combineReducers({
    QuoteOverviewReducer: QuoteOverviewReducer,
    KeyMetricsReducer: KeyMetricsReducer,
    GrowthMetricsReducer: GrowthMetricsReducer,
    ValuationReducer: ValuationReducer,
    MarketInfoReducer: MarketInfoReducer,
});
